import UtilityProgramEnrollmentPromptCardRoot, {
  Props as ComponentProps,
} from './UtilityProgramEnrollmentPromptCard'
import useViewModel from './useViewModel'
import { ViewModelComponentProps } from '../../../../utils/typeUtilities'

export type Props = ViewModelComponentProps<ComponentProps, typeof useViewModel>

export default function UtilityProgramEnrollmentPromptCard(props: Props) {
  const viewModel = useViewModel(props)
  return <UtilityProgramEnrollmentPromptCardRoot {...props} {...viewModel} />
}
